import { Overlay } from '@/shared/ui/overlay/overlay';
import './loading.css';

export interface LoadingProps {
  open: boolean;
  label?: string;
}

function noop() {}

export function Loading({ open, label = '로딩 중' }: LoadingProps) {
  return (
    <Overlay
      open={open}
      onClose={noop}
      autoFocus={false}
      trapFocus={false}
      dismissOnEscape={false}
      dismissOnOutsideClick={false}
    >
      <div className="loading" role="status">
        <img src="/images/3-dots-bounce-loading.svg" alt="" aria-hidden="true" className="loading__icon" />
        <span className="loading__visually-hidden">{label}</span>
      </div>
    </Overlay>
  );
}
